module.exports = __webpack_public_path__ + "static/img/caseImg.0306c1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg.jpg
// module id = O76W
// module chunks = 0